import {ACTIONS} from 'application/constants'

export const showToast = (message, level = 'success') => ({
    type: ACTIONS.NOTIFICATIONS_SHOW_TOAST, 
    message, 
    level
})